import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { CustomAlert, CustomButton, Text } from '../../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../../shared/Helpers/functions';
import { CopyIcon } from '../../../../../../shared/Assets/svgIcons';
import { ButtonWrapper } from '../../../../../../components/StyledComponents';

import { DispatchProperties, useSelector } from '../../../../../../redux/store';
import { copyTarget, getTargets } from '../../../../../../redux/State/clientSlice/programTargetSlice';

const Copy = ({ id, programId }: { id: string; programId: string }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const loading = useSelector((state) => state.programTarget.loading);
	const includeMastered = useSelector((state) => state.programTarget.includeMastered);
	const [openCopy, setOpenCopy] = useState<boolean>(false);

	const copyTargetHandler = () => {
		if (!id || !programId) return;

		dispatch(copyTarget({ id, programId }))
			.then(unwrapResult)
			.then(() => {
				dispatch(getTargets({ programId, includeMastered }));
				setOpenCopy(false);
				toast('Copied');
			})
			.catch(errorNormalizer);
	};

	return (
		<>
			<div className="actionRow" onClick={() => setOpenCopy(true)}>
				<div className="actionIcon">
					<CopyIcon />
				</div>
				<div className="actionContent">
					<Text title="Copy" type="psm" fontWeight="medium" />
				</div>
			</div>
			<CustomAlert
				title="Are you sure?"
				onClose={() => setOpenCopy(false)}
				open={openCopy}
				Content={() => (
					<ButtonWrapper>
						<CustomButton title="Copy target" onClick={copyTargetHandler} loading={loading} disabled={loading} />
						<CustomButton title="Cancel" buttonType="secondaryGray" onClick={() => setOpenCopy(false)} />
					</ButtonWrapper>
				)}
			/>
		</>
	);
};

export default Copy;
